import { useMutation } from "@tanstack/react-query";
import {
  refreshMatchingActivity,
  RefreshMatchingActivityParams
} from "PFCore/services/matching_activities/refresh_matching_activity";
import { MutationOptions } from "PFTypes/request_options";
import { useState } from "react";

import useRequestAttempts from "../../../use_request_attempts";
import { mutationKeys } from "../mutation_keys";

export const useMatchingActivityRefresh = (
  params: RefreshMatchingActivityParams,
  options?: MutationOptions<void>
) => {
  const [isLoading, setIsLoading] = useState(false);
  const queryKey = mutationKeys.refreshMatchingActivity(params);
  const { handleSuccessfulAttempt } = useRequestAttempts({
    queryKey
  });

  const mutation = useMutation(() => refreshMatchingActivity(params), {
    mutationKey: queryKey,
    ...options,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: (response, ...rest) => {
      handleSuccessfulAttempt(response, mutation.mutate, (response) => {
        options?.onSuccess?.(response, ...rest);
        setIsLoading(false);
      });
    },
    onError: () => {
      setIsLoading(false);
    }
  });

  return { ...mutation, isLoading };
};
